"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBox = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var input_1 = require("../input");
var button_1 = require("../button");
var controlled_1 = require("../form/controlled");
var transition_1 = require("../transition");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var noop_1 = require("../_util/noop");
var key_map_1 = require("../_util/key-map");
var call_both_1 = require("../_util/call-both");
exports.SearchBox = (0, forward_ref_with_statics_1.forwardRefWithStatics)(function (props, ref) {
    var _a, _b;
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var multiline = props.multiline, simple = props.simple, _c = props.onSearch, onSearch = _c === void 0 ? noop_1.noop : _c, _d = props.onClear, onClear = _d === void 0 ? noop_1.noop : _d, className = props.className, style = props.style, size = props.size, showHelp = props.showHelp, _e = props.onHelp, onHelp = _e === void 0 ? noop_1.noop : _e, _f = props.onFocus, onFocus = _f === void 0 ? noop_1.noop : _f, _g = props.onBlur, onBlur = _g === void 0 ? noop_1.noop : _g, tempInputProps = (0, tslib_1.__rest)(props, ["multiline", "simple", "onSearch", "onClear", "className", "style", "size", "showHelp", "onHelp", "onFocus", "onBlur"]);
    var inputBoxClassNames = (0, classnames_1.default)((_a = {},
        _a[classPrefix + "-search"] = true,
        _a[classPrefix + "-search--multi"] = multiline,
        _a[classPrefix + "-search--simple"] = simple,
        _a[className] = className,
        _a));
    var _h = (0, tslib_1.__read)((0, react_1.useState)(false), 2), focused = _h[0], setFocused = _h[1];
    var inputProps = (0, controlled_1.useDefaultValue)(tempInputProps, '');
    var composingRef = (0, react_1.useRef)(null);
    // 需要使用到 inputRef，同时向外部暴露
    var inputRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, function () { return inputRef.current; });
    var handleFocus = function () {
        setFocused(true);
        onFocus();
    };
    var handleBlur = function () {
        setFocused(false);
        onBlur();
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classPrefix + "-form--search", (_b = {},
            _b[classPrefix + "-search--has-info"] = showHelp,
            _b["size-" + (size === 'full' ? size + "-width" : size)] = size,
            _b)) },
        react_1.default.createElement("div", { className: inputBoxClassNames, style: style },
            react_1.default.createElement("div", { className: classPrefix + "-search__inner" },
                react_1.default.createElement(input_1.Input, (0, tslib_1.__assign)({ type: "search", multiline: multiline, baseClassName: classPrefix + "-input", className: classPrefix + "-input--search", onKeyDown: function (event) {
                        var key = event.key, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        if (key === key_map_1.KeyMap.Esc) {
                            event.preventDefault();
                            inputProps.onChange('', { event: event });
                            onClear();
                        }
                        // 回车处理 onSearch 逻辑
                        if (key !== key_map_1.KeyMap.Enter) {
                            return;
                        }
                        // 多行模式下，要按下 ctrl 或者 command
                        if (multiline && !metaKey && !ctrlKey) {
                            return;
                        }
                        event.preventDefault();
                        if (!composingRef.current) {
                            onSearch(event.currentTarget.value, { event: event });
                        }
                    } }, inputProps, { onCompositionStart: (0, call_both_1.callBoth)(function () {
                        composingRef.current = true;
                    }, inputProps.onCompositionStart), onCompositionEnd: (0, call_both_1.callBoth)(function () {
                        composingRef.current = false;
                    }, inputProps.onCompositionEnd), ref: inputRef, onBlur: handleBlur, onFocus: handleFocus }))),
            react_1.default.createElement(transition_1.ScaleTransition, { in: /\S/.test(inputProps.value) },
                react_1.default.createElement(button_1.Button, { icon: "dismiss", htmlType: "button", className: classPrefix + "-btn--dismiss", onClick: function (event) {
                        event.preventDefault();
                        inputProps.onChange('', { event: event });
                        onClear();
                        if (inputRef.current) {
                            inputRef.current.focus();
                        }
                    } })),
            showHelp && (react_1.default.createElement(button_1.Button, { icon: "info", htmlType: "button", className: classPrefix + "-btn--info", onClick: onHelp })),
            react_1.default.createElement(button_1.Button, { icon: "search", htmlType: "button", className: focused ? classPrefix + "-btn--search--actives" : classPrefix + "-btn--search", onClick: function (event) {
                    event.preventDefault();
                    onSearch(inputProps.value, { event: event });
                } }))));
}, {
    defaultLabelAlign: 'middle',
});
exports.SearchBox.displayName = 'SearchBox';
